export default __webpack_public_path__ + "static/media/Own.df2907b3.jpeg";